module.exports = __webpack_public_path__ + "img/stock4.11586af7.png";